// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blueprint-preview-tile--mE_KP{width:100%;border-radius:8px;cursor:pointer;background:linear-gradient(225.06deg, #DFF1F8 -19.7%, #FFF 94.59%);border:1px solid #bcd8e2}.blueprint-preview-tile--mE_KP .blueprint-preview-tile__canvas--swFH5{aspect-ratio:16/9;border-radius:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blueprint-preview-tile": "blueprint-preview-tile--mE_KP",
	"blueprint-preview-tile__canvas": "blueprint-preview-tile__canvas--swFH5"
};
export default ___CSS_LOADER_EXPORT___;
